import {
	Card,
	CardBody,
	Input,
	TableRow,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import ExportData from 'components/common/ExportData';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import { SidebarContext } from 'context/SidebarContext';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import TopSellingServices from 'services/TopSellingServices';
import { FiPlus } from 'react-icons/fi';
import TopSellingDrawer from 'components/drawer/TopSellingDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import TopSellingTable from 'components/topSelling/TopSellingTable';
import sidebar from 'routes/sidebar';

const TopSellingPackage = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { toggleDrawer } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [status, setStatus] = useState('');
	const { data, loading, error } = useAsync(TopSellingServices.getAllSlider);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const {
		topSellingRef,
		serviceData,
		dataTable,
		handleSubmitTopSelling,
		currentPage,
	} = useFilter(Array.isArray(data.data) ? data?.data : [], itemsPerPage);
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	const isDataArray = Array.isArray(data?.data); // Check if data is an array
	const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

	const isAdmin = adminInfo?.id === 1;

	const hideView = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed top selling' && perm.view === 1
		  );

	const hideDelete = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed top selling' && perm.delete === 1
		  );

	const hideEdit = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed top selling' && perm.edit === 1
		  );

	const hideAdd = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed top selling' && perm.add === 1
		  );

	const hideExport = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed top selling' && perm.export === 1
		  );
	const updatedData = safeData.map((item) => {
		const { id, ...rest } = item; // Use destructuring to remove id
		return rest; // Return the object without id
	});

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<MainDrawer>
						<TopSellingDrawer id={serviceId} />
					</MainDrawer>

					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={topSellingRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitTopSelling}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Package
									</Button>
								)}

								{hideExport && (
									<ExportData
										exportData={updatedData}
										fileNames="Top Selling Package"
									/>
								)}
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer className="mb-8">
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
											<TableRow>
												<TableCell>Sl.No.</TableCell>
												<TableCell>State</TableCell>
												<TableCell>Package Code</TableCell>
												<TableCell>Route</TableCell>
												<TableCell>No. of Days/Nights</TableCell>
												<TableCell>Actions</TableCell>
											</TableRow>
										</TableHeader>
										<TopSellingTable
											fixedItineraryPeriodicHike={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											hideEdit={hideEdit}
											hideDelete={hideDelete}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{data.status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Hour Rental Basic Rates." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default TopSellingPackage;
